<template>
    <b-card no-body>

        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <load-type-create-or-update v-model="loadType" :errors="errors"></load-type-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :add-callback="createNew"
                    :fields="fields"
                    name="load-type"
                    :buttons="buttons"
                    pagination="server"
                    search></v-table>

    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import ShipableProductApi from '@/api/shipable-product'
import LoadTypeCreateOrUpdate from './components/LoadTypeCreateOrUpdate.vue'

export default {
    components:{
        BCard,
        LoadTypeCreateOrUpdate
    },
    data(){
        return{
            editing:false,
            errors:{},
            loading:false,
            loadType:{
                Id:0,
                Name:null
            },
            fields:[
                { name:"Yükleme Tipi",key:"Name", thClass:"w-100",sortable:true,},
                
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ]
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.loadType.Id = 0
            this.loadType.Name = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.loadType.Id = item.Id
            this.loadType.Name = item.Name
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            ShipableProductApi.LoadType.CreateOrUpdate(this.editing,this.loadType)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.clearForm()
                    this.$hideModal('create-or-update')
                }
                this.$result(res)
                this.loading = false
            })
        },
        provider(data){
            return ShipableProductApi.LoadType.Table(data)
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} yükleme tipini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    ShipableProductApi.LoadType.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>